import React, { Component } from 'react';
import { Link } from "react-router-dom";
import TextInput from "../elements/TextInput";
import BoolInput from "../elements/BoolInput";
import TextAutocompleteInput from "./TextAutocompleteInput";
import Header from "./Header";
import moment from "moment";
import _ from "lodash";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ReactCountryFlag from "react-country-flag"
import { getCountryName } from "../lib/utils";

class Movie extends Component {
  
  static getDerivedStateFromProps(props, state){
    if(state.editMode){
      return {}
    }
    const movie = props.movie ? {...props.movie} : { movie_entries: [] };
    const {movie_entries} = movie;
    delete movie.movie_entries;
    const sorted_entries = _.sortBy(movie_entries, m => m.release_date.valueOf() );
    return {
      movieEdit: movie,
      movieEntriesEdit: sorted_entries,
    }
  };

  state = {
    editMode: false,
    movieEdit: {},
    movieEntriesEdit: [],
    movieModal: false,
    movieModalInput: "",
    dropdownVisible: false,
  }

  componentDidMount(){
    if(this.props.movieId){
      this.props.getAllDataForMovie(this.props.movieId)
    }
  }

  toggleEdit = () => {
    this.state.editMode ?
      this.save() :
      this.setState({editMode: true});
  }

  save = () => {
    const {movie_id, poster, original_title, english_title, is_gruvi} = this.state.movieEdit;
    this.props.updateMovie(movie_id, original_title, english_title, poster, is_gruvi);

    this.state.movieEntriesEdit.forEach( movie_entry => {
      if(movie_entry.edited){
        const {entry_id, movie_id, local_title, distributor, release_date, country, reviewed } = movie_entry;
        this.props.updateMovieEntry(entry_id, movie_id, local_title, distributor, release_date, country, reviewed );
      }
    })

    this.setState({editMode: false});
  }

  moveEntries = () => {
    this.state.movieEntriesEdit.forEach( mv_e => {
      if(mv_e.selected){
        const {entry_id, local_title, distributor, release_date, country, reviewed } = mv_e;
        const movie_id = this.state.movieModalInput;
        this.props.updateMovieEntry(entry_id, movie_id, local_title, distributor, release_date, country, reviewed );
      }
    });
    this.setState( ({movieEntriesEdit}) => {
      const new_mvs = movieEntriesEdit.filter(o => !o.selected);
      return ({movieEntriesEdit: new_mvs});
    });
  }

  deleteEntries = () => {
    this.state.movieEntriesEdit.forEach( mv_e => {
      if(mv_e.selected){
        const { entry_id, local_title, distributor, release_date, country } = mv_e;
        this.props.deleteItem(entry_id,`Do you want to delete the following entry ?\n ${local_title} - ${distributor} - ${country} - ${release_date} `);
      }
    });
    this.setState( ({movieEntriesEdit}) => {
      const new_mvs = movieEntriesEdit.filter(o => !o.selected);
      return ({movieEntriesEdit: new_mvs,dropdownVisible: false});
    });
  }

  openMovieModal = () => {
    this.setState({dropdownVisible: false});
    this.props.getAdminItems(); 
    this.setState({movieModal: true});
  }
  
  changeMovieValue = (name, value) => {
    this.setState( ({movieEdit}) => {
      movieEdit[name] = value;
      return { movieEdit }
    } )
  }

  changeMovieEntryValue = (name, value, index) => {
    this.setState( ({movieEntriesEdit}) => {
      movieEntriesEdit[index][name] = value;
      movieEntriesEdit[index]["edited"] = true;
      return { movieEntriesEdit }
    } )
  }

  render() {
    if(!this.props.movie){
      return ( 
        <div className="page">
          <Link className="header__back" to="/">
            <FontAwesomeIcon icon="chevron-left" />
            <div>Back</div>
          </Link>
          <p>loading</p>
        </div>
      );
    }

    console.log(this.props.movie)
    return (
      <div className={`movie ${this.state.editMode ? "movie--edit" : ""}`}>
        <Link className="header__back" to="/">
          <FontAwesomeIcon icon="chevron-left" />
          <div>Back</div>
        </Link>
        {this.props.authed ? <div className="edit-button" onClick={ this.toggleEdit }>{!this.state.editMode ? "Edit" : "Save"}</div> : <div></div>}
        <div className="movie__main" >
          <div className="movie__left">
            <div className="movie__poster">
              <img src={this.state.movieEdit.poster}/>
            </div>
            {this.props.authed && this.state.editMode ?
              (<div className="button-options">
                <TextInput
                  edit={this.state.editMode}
                  value={this.state.movieEdit.poster}
                  name="poster"
                  changeValue={ this.changeMovieValue }
                />
                <div>Is Gruvi Movie?</div>
                <BoolInput
                  edit={this.state.editMode}
                  value={this.state.movieEdit.is_gruvi}
                  name="is_gruvi"
                  changeValue={ this.changeMovieValue }
                />
              </div>) :
              (<Link className="contact-link" to="/release-form">
                <FontAwesomeIcon icon="exclamation-triangle" />
                <div>Notify us of release updates/changes</div>
              </Link>)
            }
          </div>
          <div className="movie__info">
            <div className="movie__title movie__title--english">
              <TextInput
                edit={this.state.editMode}
                value={this.state.movieEdit.english_title}
                name="english_title"
                changeValue={ this.changeMovieValue }
              />
              {this.state.editMode && <div className="edit-helper">English Title</div>}
              {this.props.authed && this.props.movie.is_gruvi? (<span className="movie__title__gruvi">Gruvi Movie</span>) : ""}
            </div>
            <div className="movie__title movie__title--original">
              <TextInput
                edit={this.state.editMode}
                value={this.state.movieEdit.original_title}
                name="original_title"
                changeValue={ this.changeMovieValue }
              />
              {this.state.editMode && <div className="edit-helper">Original Title</div>}
            </div>
            {this.props.authed && this.state.editMode && <div className="dropdown">
              <div onClick={ () => this.setState( ({dropdownVisible}) => ({dropdownVisible: !dropdownVisible}) )} >Selected entries <FontAwesomeIcon icon="angle-down" /></div>
              <div className={`dropdown__box ${!this.state.dropdownVisible ? "dropdown__box--collapsed" : ""}`} >
                <div onClick={this.openMovieModal}>Move</div>
                <div onClick={this.deleteEntries}>Delete</div>
              </div>
            </div>}
            <div className="movie__list">
              <div className="movie__list__header">
                <div/>
                <div/>
                <div>Country</div>
                <div>Local Title</div>
                <div>Distributor</div>
                <div>Release Date</div>
                <div></div>
              </div>
              {this.state.movieEntriesEdit.map( (o,i) => 
                <div
                  key={o.entry_id}
                  className={`movie__list__item ${o.release_date && moment(o.release_date,"YYYY-MM-DD").isBefore(moment(),'day') ?  "movie__list__item--old" : ""} ${o.selected ? "movie__list__item--selected" : ""}`}
                >
                  {!this.state.editMode ?
                    <div/> : 
                    <BoolInput
                      edit={this.state.editMode}
                      value={!!o.selected}
                      name="selected"
                      changeValue={ (n,v) => this.changeMovieEntryValue(n, v, i) }
                    />
                  }
                  <ReactCountryFlag svg countryCode={o.country.toUpperCase()} />
                  <div>{getCountryName(o.country)}</div>
                  <TextInput
                    edit={this.state.editMode}
                    value={o.local_title}
                    name="local_title"
                    changeValue={ (n,v) => this.changeMovieEntryValue(n, v, i) }
                  />
                  <TextInput
                    edit={this.state.editMode}
                    value={o.distributor}
                    name="distributor"
                    changeValue={ (n,v) => this.changeMovieEntryValue(n, v, i) }
                  />
                  <TextInput
                    edit={this.state.editMode}
                    value={o.release_date}
                    name="release_date"
                    changeValue={ (n,v) => this.changeMovieEntryValue(n, v, i) }
                  />
                  {this.props.authed ? <BoolInput
                    edit={this.state.editMode}
                    circle
                    value={o.reviewed}
                    name="reviewed"
                    changeValue={ (n,v) => this.changeMovieEntryValue(n, v, i) }
                  /> : <div/>}
                </div>
              )}
            </div>
          </div>
          {this.state.movieModal &&
            <div className="modal">
              <div className="modal__content">
                <div className="modal__exit" onClick={() => this.setState({movieModalInput: "", movieModal: false})}>X</div>
                <TextAutocompleteInput 
                  placeholder="movie"
                  itemValue={ (item) => item.movie_id }
                  itemLabel={ (item) => item.english_title }
                  itemKey={ (item) => item.movie_id }
                  value={this.state.movieModalInput}
                  items={Object.values(this.props.movies).filter(o => _.includes(_.lowerCase(o.english_title), _.lowerCase(this.state.movieModalInput) ) )}
                  onChange={(v) => this.setState({movieModalInput: v})}
                  onSelect={(v) => this.setState({movieModalInput: v})}
                  inputHeight="22px"
                />
                <button onClick={this.moveEntries}>Save</button>
              </div>
            </div>
          }
        </div>
      </div>
    );
  }

}

export default Movie;



// WEBPACK FOOTER //
// ./src/components/Movie.js